(function(){
try{
var H='personalised-retro-travel-map-pop-art-print';
function tc(s){return s.replace(/\s+/g,' ').replace(/[^\s-]+/g,function(w){return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase()})}
function setv(el,v){if(!el||el.value===v)return;var s=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set;s.call(el,v);el.dispatchEvent(new Event('input',{bubbles:true}));el.dispatchEvent(new Event('change',{bubbles:true}));el.dispatchEvent(new Event('blur',{bubbles:true}))}
function phrase(v){return v.toUpperCase()+' IS ALWAYS A GOOD IDEA'}
/* 1) Product page: fill the custom map form from ?mp_loc= */
var p=new URLSearchParams(location.search),loc=(p.get('mp_loc')||'').trim().slice(0,60);
if(location.pathname.indexOf('/products/')===0){
var dirty=false;
document.addEventListener('input',function(e){var t=e.target;if(!t||!t.name||!e.isTrusted)return;
 if(t.name==='Text to go over map'){dirty=true;return}
 if(t.name==='Map Location'&&!dirty){var b=document.querySelector('input[name="Text to go over map"]'),v=t.value.trim().replace(/,.*$/,'').trim();setv(b,v?phrase(v):'')}},true);
if(loc){var n=0;
var t=setInterval(function(){n++;
 var a=document.querySelector('input[name="Map Location"]'),b=document.querySelector('input[name="Text to go over map"]');
 if(a&&b){if(!a.value)setv(a,loc);if(!b.value)setv(b,phrase(loc));if(a.value&&b.value){clearInterval(t);
  var w=a.closest('.gpo-element,.gpo-form__group')||a;setTimeout(function(){w.scrollIntoView({behavior:'smooth',block:'center'})},400)}}
 if(n>60)clearInterval(t)},250)}
}
/* 2) Map hub search box: add the typed place to custom map links; hide the flat map when the globe is on the page */
function wm(){var box=document.querySelector('.wm .wm-sbox');if(!box)return;
 if(document.querySelector('.mpg')&&document.querySelector('.wm.wm-hub')){var s=document.createElement('style');s.textContent='.wm-hub .wm-toggle,.wm-hub .wm-mapbox,.wm-hub .wm-swipe{display:none!important}';document.head.appendChild(s)}
 function fix(){var v=tc(box.value.trim()).slice(0,60);
  document.querySelectorAll('.wm a[href*="'+H+'"]').forEach(function(a){var b=a.getAttribute('href').split('?')[0];a.setAttribute('href',v.length>=2?b+'?mp_loc='+encodeURIComponent(v):b)})}
 var tm;function sch(){clearTimeout(tm);tm=setTimeout(fix,60)}
 box.addEventListener('input',function(){setTimeout(fix,250)});
 if(window.MutationObserver)new MutationObserver(sch).observe(document.querySelector('.wm'),{childList:true,subtree:true});
 fix()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wm);else wm();
}catch(e){}
})();
